import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthContextProvider } from './context/authContext/AuthContext';
import { AgenceContextProvider } from './context/agenceContext/AgenceContext';
import { EntrepriseContextProvider } from './context/entrepriseContext/EntrepriseContext';
import { DeliveryContextProvider } from './context/deliveryContext/DeliveryContext';
import { ClientContextProvider } from './context/clientContext/ClientContext';
import { EnvoieContextProvider } from './context/envoieContext/EnvoieContext';
import { CartContextProvider } from './context/cartContext/CartContext';
import { VoyageContextProvider } from './context/voyageContext/VoyageContext';
import { BagageContextProvider } from './context/bagageContext/BagageContext';
import { ActionEnvoieContextProvider } from './context/actionEnvoieContext/ActionEnvoieContext';
import { AgentContextProvider } from './context/agentContext/AgentContext';
import { MovementContextProvider } from './context/movementContext/MovementContext';
import { InvoiceContextProvider } from './context/invoiceContext/InvoiceContext';
import { SettingContextProvider } from './context/settingContext/SettingContext';
import { InfopersonContextProvider } from './context/infopersonContext/InfopersonContext';
import { StatistiqueContextProvider } from './context/statistiqueContext/StatistiqueContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StatistiqueContextProvider>
      <InfopersonContextProvider>
        <SettingContextProvider>
          <InvoiceContextProvider>
            <MovementContextProvider>
              <AgentContextProvider>
                <BagageContextProvider>
                  <ActionEnvoieContextProvider>
                    <VoyageContextProvider>
                      <CartContextProvider>
                        <EnvoieContextProvider>
                          <ClientContextProvider>
                            <DeliveryContextProvider>
                              <EntrepriseContextProvider>
                                <AgenceContextProvider>
                                  <AuthContextProvider>
                                    <App />
                                  </AuthContextProvider>
                                </AgenceContextProvider>
                              </EntrepriseContextProvider>
                            </DeliveryContextProvider>
                          </ClientContextProvider>
                        </EnvoieContextProvider>
                      </CartContextProvider>
                    </VoyageContextProvider>
                  </ActionEnvoieContextProvider>
                </BagageContextProvider>
              </AgentContextProvider>
            </MovementContextProvider>
          </InvoiceContextProvider>
        </SettingContextProvider>
      </InfopersonContextProvider>
    </StatistiqueContextProvider>
  </React.StrictMode>
);
